import { redirectToLogin } from "@src/appV2/Auth/redirectToLogin";
import axios from "axios";

/**
 * Response-interceptor error handler. Catches 401s centrally and bounces
 * the user to /login. `redirectToLogin` is idempotent and no-ops on login
 * routes, so concurrent failing requests don't loop.
 *
 * The 401 path returns a never-resolving promise rather than re-throwing.
 * Throwing would propagate the rejection to callers — useQuery onError,
 * `meta.logErrorMessage`, ad-hoc `.catch()` handlers — and a generic error
 * toast would flash in the brief window before the browser navigates to
 * /login. Resolving with undefined would crash callers reading
 * `response.data` in that same window. Holding the promise pending keeps
 * the caller in its loading state until React tears down on navigation.
 */
export async function handleApiResponseError(error: unknown): Promise<void> {
  if (axios.isAxiosError(error) && error.response?.status === 401) {
    redirectToLogin("apiClient");
    return new Promise<never>(() => {
      // Intentionally never resolves — see comment above.
    });
  }
  if (error instanceof Error) {
    throw error;
  }
}
